(() => {
  function cleanText(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function getCurrentProductPrice(productRoot) {
    if (!productRoot) return '';

    const currentPrice =
      productRoot.querySelector('[id^="price-"] .price-item--sale') ||
      productRoot.querySelector('[id^="price-"] .price-item--regular') ||
      productRoot.querySelector('[id^="price-"] .price__regular .price-item') ||
      productRoot.querySelector('[id^="price-"] .price__sale .price-item');

    return currentPrice ? cleanText(currentPrice.textContent) : '';
  }

  function setupDesktopPurchaseRailOffset() {
    const productRoot = document.querySelector('.mio-pdp');
    const purchaseRail = productRoot ? productRoot.querySelector('[data-mio-purchase-rail]') : null;

    if (!productRoot || !purchaseRail) return;

    let ticking = false;

    function getHeaderOffset() {
      const stickyHeader =
        document.querySelector('.shopify-section-header-sticky') ||
        document.querySelector('sticky-header') ||
        document.querySelector('.section-header');
      const headerRect = stickyHeader ? stickyHeader.getBoundingClientRect() : null;
      const headerBottom = headerRect ? Math.max(0, headerRect.bottom) : 0;

      return Math.max(84, Math.round(headerBottom + 16));
    }

    function update() {
      ticking = false;
      productRoot.style.setProperty('--mio-pdp-sticky-top', `${getHeaderOffset()}px`);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    requestUpdate();
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('load', requestUpdate);
    document.addEventListener('shopify:section:load', requestUpdate);
  }

  function setupStickyAddToCart() {
    const stickyBar = document.querySelector('[data-mio-sticky-atc]');
    const productRoot = document.querySelector('.mio-pdp');

    if (!stickyBar || !productRoot) return;
    if (stickyBar.dataset.mioStickyBound === 'true') return;
    stickyBar.dataset.mioStickyBound = 'true';

    const getPrimaryButton = () =>
      productRoot.querySelector('[id^="ProductSubmitButton-"]') ||
      productRoot.querySelector('.product-form__submit') ||
      productRoot.querySelector('button[name="add"]');
    const getMainQuantityInput = () =>
      productRoot.querySelector('.mio-purchase-panel__quantity-control .quantity__input');
    const getMainStock = () => productRoot.querySelector('[data-mio-buybox-stock]');
    const primaryButton = getPrimaryButton();
    const stickyButton = stickyBar.querySelector('[data-mio-sticky-atc-button]');
    const stickyButtonLabel = stickyBar.querySelector('[data-mio-sticky-atc-label]');
    const stickyPrice = stickyBar.querySelector('[data-mio-sticky-atc-price]');
    const stickyCompare = stickyBar.querySelector('[data-mio-sticky-atc-compare]');
    const stickyStock = stickyBar.querySelector('[data-mio-sticky-atc-stock]');
    const stickyQuantity = stickyBar.querySelector('[data-mio-sticky-atc-quantity]');
    const stickyQuantityInput = stickyBar.querySelector('[data-mio-sticky-atc-quantity-input]');
    const stickyQuantityMinus = stickyBar.querySelector('[data-mio-sticky-atc-quantity-minus]');
    const stickyQuantityPlus = stickyBar.querySelector('[data-mio-sticky-atc-quantity-plus]');
    const stickyImage = stickyBar.querySelector('[data-mio-sticky-atc-image]');
    const priceContainer = productRoot.querySelector('[id^="price-"]');
    const triggerElement = primaryButton;
    let stickyVariantState = getInitialStickyVariantState();
    let layoutTicking = false;
    let layoutFallbackTimer = null;
    let syncingQuantity = false;
    let stickySubmitInFlight = false;
    let stickyFeedbackText = '';
    let stickyFeedbackTimer = null;
    let hasSeenMainCta = false;

    if (!primaryButton || !triggerElement) return;

    function getCurrentComparePrice() {
      if (!productRoot) return '';

      const comparePrice =
        productRoot.querySelector('[id^="price-"] .price__sale s.price-item') ||
        productRoot.querySelector('[id^="price-"] s.price-item--regular') ||
        productRoot.querySelector('[id^="price-"] .price__sale .price-item--regular');

      return comparePrice ? cleanText(comparePrice.textContent) : '';
    }

    function syncStickyPrice() {
      if (!stickyPrice) return;

      const priceText = getCurrentProductPrice(productRoot);

      if (priceText) {
        stickyPrice.textContent = priceText;
      }

      if (stickyCompare) {
        const compareText = getCurrentComparePrice();
        const currentText = cleanText(stickyPrice.textContent);
        const hasCompare = compareText && compareText !== currentText;

        stickyCompare.textContent = hasCompare ? compareText : '';
        stickyCompare.hidden = !hasCompare;
      }
    }

    function getStickyButtonText(primaryLabel, isDisabled, isLoading) {
      const labelText = cleanText(primaryLabel).toLowerCase();

      if (labelText.includes('max in basket')) return 'Max in basket';
      if (labelText.includes('unavailable')) return 'Unavailable';
      if (labelText.includes('sold out')) return 'Sold out';
      if (stickyFeedbackText) return stickyFeedbackText;
      if (stickySubmitInFlight || isLoading) return 'Adding...';

      return isDisabled ? 'Unavailable' : 'Add to basket';
    }

    function clearStickyFeedback() {
      if (stickyFeedbackTimer) {
        window.clearTimeout(stickyFeedbackTimer);
        stickyFeedbackTimer = null;
      }
      stickyFeedbackText = '';
    }

    function setStickyFeedback(text, duration = 0) {
      clearStickyFeedback();
      stickyFeedbackText = text;
      syncStickyButton();

      if (duration > 0) {
        stickyFeedbackTimer = window.setTimeout(() => {
          stickyFeedbackTimer = null;
          stickyFeedbackText = '';
          syncStickyButton();
        }, duration);
      }
    }

    function getStickyCartErrorText(event) {
      const errorText = cleanText(
        [
          event?.data?.message,
          event?.data?.errors,
          event?.data?.description,
          event?.message,
          event?.errors,
          event?.description
        ]
          .filter(Boolean)
          .join(' ')
      ).toLowerCase();

      if (errorText.includes('sold out')) return 'Sold out';
      if (errorText.includes('unavailable')) return 'Unavailable';
      if (
        errorText.includes('max') ||
        errorText.includes('maximum') ||
        errorText.includes('already') ||
        errorText.includes('quantity') ||
        errorText.includes('not enough') ||
        errorText.includes('cannot add')
      ) {
        return 'Max in basket';
      }

      return 'Add to basket';
    }

    function getStickyStockText(sourceText, state) {
      const text = cleanText(sourceText);
      const lowerText = text.toLowerCase();
      const lowMatch = text.match(/Only\s+(\d+)\s+left/i);
      const inStockMatch = text.match(/^(\d+)\s+in stock/i);

      if (lowMatch) return `Only ${lowMatch[1]} left`;
      if (lowerText.includes('last one')) return 'Only 1 left';
      if (lowerText.includes('currently unavailable')) return 'Currently unavailable';
      if (lowerText.includes('available to order')) return 'Available to order';
      if (state === 'sold-out') return 'Currently unavailable';
      if (state === 'urgent') return 'Only 1 left';
      if (inStockMatch) return 'In stock';

      return 'In stock';
    }

    function syncStickyStock() {
      if (!stickyStock) return;

      const mainStock = getMainStock();
      const state = mainStock?.dataset.stockState || stickyStock.dataset.stockState || 'available';
      const message = getStickyStockText(mainStock?.textContent || stickyStock.textContent, state);

      stickyStock.textContent = message;
      stickyStock.dataset.stockState = state;
    }

    function getInitialStickyVariantState() {
      const selectedVariantScript = productRoot.querySelector('script[data-selected-variant]');

      if (!selectedVariantScript || !selectedVariantScript.textContent) return null;

      try {
        return JSON.parse(selectedVariantScript.textContent);
      } catch (error) {
        return null;
      }
    }

    function syncStickyImage(variant) {
      if (!stickyImage || !variant?.featured_media?.preview_image?.src) return;

      const nextSrc = variant.featured_media.preview_image.src;
      if (nextSrc && stickyImage.src !== nextSrc) {
        stickyImage.src = nextSrc;
      }
    }

    function setStickyQuantityFocusable(isFocusable) {
      if (!stickyQuantityInput || !stickyQuantityMinus || !stickyQuantityPlus) return;

      const tabIndex = isFocusable ? 0 : -1;
      stickyQuantityInput.tabIndex = tabIndex;
      stickyQuantityMinus.tabIndex = tabIndex;
      stickyQuantityPlus.tabIndex = tabIndex;
    }

    function copyQuantityConstraints() {
      const mainQuantityInput = getMainQuantityInput();

      if (!stickyQuantityInput || !mainQuantityInput) {
        if (stickyQuantity) stickyQuantity.hidden = true;
        return;
      }

      ['min', 'max', 'step'].forEach((attribute) => {
        const value = mainQuantityInput.getAttribute(attribute);
        if (value == null || value === '') {
          stickyQuantityInput.removeAttribute(attribute);
        } else {
          stickyQuantityInput.setAttribute(attribute, value);
        }
      });

      stickyQuantityInput.value = mainQuantityInput.value || mainQuantityInput.min || '1';
      if (stickyQuantity) stickyQuantity.hidden = false;
      syncStickyQuantityButtons();
    }

    function clampStickyQuantity(value) {
      const min = Number(stickyQuantityInput?.min || 1);
      const max = Number(stickyQuantityInput?.max || 0);
      const numericValue = Number(value);
      let nextValue = Number.isFinite(numericValue) ? numericValue : min;

      if (Number.isFinite(min)) nextValue = Math.max(min, nextValue);
      if (Number.isFinite(max) && max > 0) nextValue = Math.min(max, nextValue);

      return String(nextValue);
    }

    function syncStickyQuantityButtons() {
      if (!stickyQuantityInput) return;

      const value = Number(stickyQuantityInput.value || stickyQuantityInput.min || 1);
      const min = Number(stickyQuantityInput.min || 1);
      const max = Number(stickyQuantityInput.max || 0);
      const atMin = Number.isFinite(min) && value <= min;
      const atMax = Number.isFinite(max) && max > 0 && value >= max;

      if (stickyQuantityMinus) {
        stickyQuantityMinus.disabled = atMin;
        stickyQuantityMinus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      }

      if (stickyQuantityPlus) {
        stickyQuantityPlus.disabled = atMax;
        stickyQuantityPlus.setAttribute('aria-disabled', atMax ? 'true' : 'false');
      }
    }

    function pushStickyQuantityToMain() {
      const mainQuantityInput = getMainQuantityInput();

      if (!stickyQuantityInput || !mainQuantityInput || syncingQuantity) return;

      syncingQuantity = true;
      const nextValue = clampStickyQuantity(stickyQuantityInput.value);

      stickyQuantityInput.value = nextValue;
      if (mainQuantityInput.value !== nextValue) {
        mainQuantityInput.value = nextValue;
        mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncingQuantity = false;
      syncStickyQuantityButtons();
    }

    function pullMainQuantityToSticky() {
      const mainQuantityInput = getMainQuantityInput();

      if (!stickyQuantityInput || !mainQuantityInput || syncingQuantity) return;

      syncingQuantity = true;
      copyQuantityConstraints();
      stickyQuantityInput.value = mainQuantityInput.value || mainQuantityInput.min || '1';
      syncingQuantity = false;
      syncStickyQuantityButtons();
    }

    function syncStickyButton() {
      if (!stickyButton) return;

      const currentPrimaryButton = getPrimaryButton() || primaryButton;
      const isLoading = currentPrimaryButton.classList.contains('loading');
      const isDisabled =
        currentPrimaryButton.disabled || currentPrimaryButton.getAttribute('aria-disabled') === 'true' || isLoading;
      const primaryLabel = cleanText(currentPrimaryButton.textContent);

      if (!isDisabled) {
        stickySubmitInFlight = false;
      }

      stickyButton.disabled = isDisabled || stickySubmitInFlight;
      stickyButton.setAttribute('aria-disabled', stickyButton.disabled ? 'true' : 'false');

      if (stickyButtonLabel) {
        stickyButtonLabel.textContent = getStickyButtonText(primaryLabel, isDisabled, isLoading);
      }

      syncStickyPrice();
      syncStickyStock();
      syncStickyImage(stickyVariantState);
      pullMainQuantityToSticky();
    }

    function updateCookieOffset() {
      const cookieBanner = document.querySelector(
        '.shopify-pc__banner__dialog, #shopify-pc__banner, .shopify-pc__banner__wrapper, [id*="cookie"][role="dialog"]'
      );
      const rect = cookieBanner ? cookieBanner.getBoundingClientRect() : null;
      const isVisible = rect && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
      const offset = isVisible ? Math.ceil(rect.height + 12) : 0;

      document.documentElement.style.setProperty('--mio-sticky-cookie-offset', `${offset}px`);
    }

    function setStickyVisibility(visible) {
      const shouldShow = Boolean(visible);

      syncStickyButton();
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      document.documentElement.classList.toggle('mio-product-sticky-atc-visible', shouldShow);
      document.body?.classList.toggle('mio-product-sticky-atc-visible', shouldShow);

      if (stickyButton) {
        stickyButton.tabIndex = shouldShow ? 0 : -1;
      }
      setStickyQuantityFocusable(shouldShow);
    }

    function isNearPageEnd(viewportHeight) {
      const documentElement = document.documentElement;
      const scrollElement = document.scrollingElement || documentElement;
      const scrollHeight = Math.max(
        documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      const bottomDistance = scrollHeight - (scrollElement.scrollTop + viewportHeight);
      const stickyHeight = stickyBar.getBoundingClientRect().height || 0;
      const endThreshold = Math.max(stickyHeight + 24, viewportHeight * 0.01);

      return bottomDistance <= endThreshold;
    }

    function updateFromLayout() {
      layoutTicking = false;
      if (layoutFallbackTimer) {
        window.clearTimeout(layoutFallbackTimer);
        layoutFallbackTimer = null;
      }
      updateCookieOffset();

      const triggerRect = triggerElement.getBoundingClientRect();
      const productRect = productRoot.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const visibleBandTop = Math.max(0, viewportHeight * 0.08);
      const visibleBandBottom = viewportHeight * 0.94;
      const triggerIsUsablyVisible =
        triggerRect.top < visibleBandBottom && triggerRect.bottom > visibleBandTop;
      const triggerHasScrolledAbove = triggerRect.bottom <= visibleBandTop;
      const productSectionIsEnding = productRect.bottom <= viewportHeight * 0.42;
      const pageEndIsNear = isNearPageEnd(viewportHeight);

      if (triggerIsUsablyVisible || triggerHasScrolledAbove) {
        hasSeenMainCta = true;
      }

      setStickyVisibility(hasSeenMainCta && (triggerHasScrolledAbove || productSectionIsEnding) && !pageEndIsNear);
    }

    function flushLayoutUpdate() {
      if (!layoutTicking) return;
      updateFromLayout();
    }

    function requestLayoutUpdate() {
      if (layoutTicking) return;
      layoutTicking = true;
      layoutFallbackTimer = window.setTimeout(flushLayoutUpdate, 120);
      window.requestAnimationFrame(flushLayoutUpdate);
    }

    stickyBar.setAttribute('aria-hidden', 'true');
    if (stickyButton) stickyButton.tabIndex = -1;
    setStickyQuantityFocusable(false);
    pullMainQuantityToSticky();
    syncStickyStock();
    syncStickyButton();

    if (stickyButton) {
      stickyButton.addEventListener('click', (event) => {
        event.preventDefault();

        syncStickyButton();
        pushStickyQuantityToMain();

        const currentPrimaryButton = getPrimaryButton() || primaryButton;
        const primaryIsBusy =
          currentPrimaryButton.disabled ||
          currentPrimaryButton.getAttribute('aria-disabled') === 'true' ||
          currentPrimaryButton.classList.contains('loading');

        if (stickyButton.disabled || stickySubmitInFlight || primaryIsBusy) {
          return;
        }

        clearStickyFeedback();
        stickySubmitInFlight = true;
        stickyButton.disabled = true;
        stickyButton.setAttribute('aria-disabled', 'true');
        if (stickyButtonLabel) {
          stickyButtonLabel.textContent = 'Adding...';
        }
        currentPrimaryButton.click();
      });
    }

    if (stickyQuantityInput) {
      stickyQuantityInput.addEventListener('input', () => {
        pushStickyQuantityToMain();
      });
      stickyQuantityInput.addEventListener('change', () => {
        pushStickyQuantityToMain();
      });
    }

    if (stickyQuantityMinus) {
      stickyQuantityMinus.addEventListener('click', () => {
        if (!stickyQuantityInput || stickyQuantityMinus.disabled) return;
        stickyQuantityInput.stepDown();
        pushStickyQuantityToMain();
      });
    }

    if (stickyQuantityPlus) {
      stickyQuantityPlus.addEventListener('click', () => {
        if (!stickyQuantityInput || stickyQuantityPlus.disabled) return;
        stickyQuantityInput.stepUp();
        pushStickyQuantityToMain();
      });
    }

    const mainQuantityInput = getMainQuantityInput();
    if (mainQuantityInput) {
      mainQuantityInput.addEventListener('input', pullMainQuantityToSticky);
      mainQuantityInput.addEventListener('change', pullMainQuantityToSticky);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        stickyVariantState = event?.data?.variant || stickyVariantState;
        clearStickyFeedback();
        syncStickyButton();
      });

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.source !== 'product-form' || !stickySubmitInFlight) return;

        stickySubmitInFlight = false;
        setStickyFeedback('Added', 1800);
      });

      subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        if (event?.source !== 'product-form' || !stickySubmitInFlight) return;

        stickySubmitInFlight = false;
        setStickyFeedback(getStickyCartErrorText(event), 2400);
      });
    }

    const stickyStateObserver = new MutationObserver(syncStickyButton);
    stickyStateObserver.observe(primaryButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    if (priceContainer) {
      const stickyPriceObserver = new MutationObserver(syncStickyPrice);
      stickyPriceObserver.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    const mainStock = getMainStock();
    if (mainStock) {
      const stickyStockObserver = new MutationObserver(syncStickyStock);
      stickyStockObserver.observe(mainStock, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
        attributeFilter: ['data-stock-state']
      });
    }

    updateFromLayout();
    window.addEventListener('scroll', requestLayoutUpdate, { passive: true });
    window.addEventListener('resize', () => {
      requestLayoutUpdate();
    });
    window.addEventListener('load', () => {
      requestLayoutUpdate();
    });
    if ('IntersectionObserver' in window) {
      const stickyTriggerObserver = new IntersectionObserver(requestLayoutUpdate, {
        threshold: [0, 1]
      });
      stickyTriggerObserver.observe(triggerElement);
    }
    document.addEventListener('shopify:section:load', () => {
      updateFromLayout();
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateFromLayout();
    });
  }

  function setupPurchasePanelEnhancements() {
    const productRoot = document.querySelector('.mio-pdp');
    const purchasePanel = productRoot ? productRoot.querySelector('[data-mio-purchase-rail]') : null;
    const priceContainer = productRoot ? productRoot.querySelector('[id^="price-"]') : null;

    if (!productRoot || !purchasePanel) return;

    const stockStatus = purchasePanel.querySelector('[data-mio-buybox-stock]');
    const quantityInput = purchasePanel.querySelector('.mio-purchase-panel__quantity-control .quantity__input');
    const plusButton = purchasePanel.querySelector('.mio-purchase-panel__quantity-control .quantity__button[name="plus"]');
    const minusButton = purchasePanel.querySelector('.mio-purchase-panel__quantity-control .quantity__button[name="minus"]');
    let currentVariantState = null;
    let stockMaxedInCart = false;
    let currencyNodes = [];

    function removeCurrencyCode(text) {
      return cleanText(String(text || '').replace(/\s*GBP\b/gi, ''));
    }

    function refreshCurrencyNodes() {
      currencyNodes = Array.from(
        document.querySelectorAll(
          '.mio-pdp [id^="price-"] .price-item, .mio-pdp [id^="price-"] .price__savings-amount, .mio-pdp [data-mio-main-atc-price], .mio-pdp [data-mio-sticky-atc-price], .mio-pdp-related-flow .price-item, .mio-pdp-related-flow .price__savings-amount, .mio-product-sticky-atc__price'
        )
      );
    }

    function normalizeVisibleCurrency() {
      if (!currencyNodes.length) {
        refreshCurrencyNodes();
      }

      currencyNodes.forEach((node) => {
        const nextText = removeCurrencyCode(node.textContent);
        if (nextText && node.textContent !== nextText) {
          node.textContent = nextText;
        }
      });
    }

    function normalizeTaxNote() {
      const taxNode = productRoot.querySelector('.mio-pdp__tax-note .product__tax');
      if (!taxNode) return;

      // Keep richer tax/shipping markup intact.
      if (taxNode.querySelector('a, strong, em, span')) return;

      const taxText = cleanText(taxNode.textContent).replace(/[()]/g, '');
      if (taxText.toLowerCase() === 'taxes included.') {
        taxNode.textContent = '(Taxes included.)';
      } else if (taxText.toLowerCase().startsWith('taxes included')) {
        taxNode.textContent = `(${taxText.charAt(0).toUpperCase()}${taxText.slice(1)})`;
      }
    }

    function getMainButton() {
      return purchasePanel.querySelector('[data-mio-main-atc-button]');
    }

    function getButtonLabel(button) {
      return button ? button.querySelector('[data-mio-main-atc-label]') : null;
    }

    function syncPrimaryButtonLabel() {
      const button = getMainButton();
      const label = getButtonLabel(button);

      if (!button || !label) return;

      if (stockMaxedInCart) {
        label.textContent = 'Max in basket';
        return;
      }

      const labelText = cleanText(label.textContent);
      const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
      const disabledReason = labelText.toLowerCase();

      if (disabled && (disabledReason.includes('sold out') || disabledReason.includes('unavailable'))) {
        return;
      }

      const priceText = getCurrentProductPrice(productRoot);
      const inlinePriceNode = label.querySelector('[data-mio-main-atc-price]');
      if (inlinePriceNode) {
        if (priceText && cleanText(inlinePriceNode.textContent) !== priceText) {
          inlinePriceNode.textContent = priceText;
        }
      } else {
        const nextLabel = priceText ? `Add to basket \u00b7 ${priceText}` : 'Add to basket';
        if (labelText !== nextLabel) {
          label.textContent = nextLabel;
        }
      }

      normalizeVisibleCurrency();
    }

    function setStockMaxedInCart(isMaxed, variant) {
      const button = getMainButton();
      stockMaxedInCart = Boolean(isMaxed);

      if (button) {
        if (stockMaxedInCart) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          button.dataset.mioStockMaxed = 'true';
        } else if (button.dataset.mioStockMaxed === 'true') {
          delete button.dataset.mioStockMaxed;
          if (!variant || variant.available) {
            button.disabled = false;
            button.setAttribute('aria-disabled', 'false');
          }
        }
      }

      syncPrimaryButtonLabel();
    }

    function syncStockStatus(variant) {
      if (!variant) return;

      const pauseNotice = purchasePanel.querySelector('[data-mio-dispatch-pause-buybox]');
      if (pauseNotice) pauseNotice.hidden = !variant.available;
      if (!stockStatus) return;

      let message = 'In stock · Ready to dispatch';
      let state = 'available';
      const quantity = Number(variant.inventory_quantity);
      const hasFiniteQuantity = Number.isFinite(quantity);
      const managedByShopify = variant.inventory_management === 'shopify';
      const canContinueSelling = managedByShopify && variant.inventory_policy === 'continue';

      if ((!variant.available && !canContinueSelling) || (managedByShopify && !canContinueSelling && hasFiniteQuantity && quantity <= 0)) {
        message = 'Currently unavailable';
        state = 'sold-out';
      } else if (canContinueSelling) {
        message = 'Available to order';
      } else if (managedByShopify && hasFiniteQuantity) {
        if (quantity === 1) {
          message = 'Last one available · Order soon';
          state = 'urgent';
        } else if (quantity <= 4) {
          message = `Only ${quantity} left · Low stock`;
          state = 'low';
        } else if (quantity <= 9) {
          message = `${quantity} in stock · Ready to dispatch`;
        } else {
          message = 'In stock · Ready to dispatch';
        }
      } else {
        message = 'In stock · Ready to dispatch';
      }

      if (stockStatus.dataset.dispatchPauseEnabled === 'true') {
        message = message.replace(' · Ready to dispatch', '');
      }

      stockStatus.textContent = message;
      stockStatus.dataset.stockState = state;
    }

    function getInitialVariantState() {
      const selectedVariantScript = productRoot.querySelector('script[data-selected-variant]');
      if (selectedVariantScript && selectedVariantScript.textContent) {
        try {
          return JSON.parse(selectedVariantScript.textContent);
        } catch (error) {
          // Fall back to quantity data attributes below when selected variant JSON is unavailable.
        }
      }

      if (!quantityInput) return null;

      const inventoryQuantity = Number(quantityInput.dataset.inventoryQuantity);
      const quantityRuleMax = Number(quantityInput.dataset.max);

      return {
        available: quantityInput.dataset.variantAvailable !== 'false',
        inventory_management: quantityInput.dataset.inventoryManagement || null,
        inventory_policy: quantityInput.dataset.inventoryPolicy || null,
        inventory_quantity: Number.isFinite(inventoryQuantity) ? inventoryQuantity : null,
        quantity_rule: {
          min: quantityInput.min ? Number(quantityInput.min) : null,
          max: Number.isFinite(quantityRuleMax) && quantityRuleMax > 0 ? quantityRuleMax : null
        }
      };
    }

    function syncMinusButton() {
      if (!quantityInput || !minusButton) return;

      const minQty = Number(quantityInput.min || 1);
      const currentQty = Number(quantityInput.value || minQty);
      const atMin = currentQty <= minQty;

      minusButton.disabled = atMin;
      minusButton.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      if (atMin) {
        minusButton.title = 'Minimum quantity reached';
      } else {
        minusButton.removeAttribute('title');
      }
    }

    function applyQuantityCap(variant) {
      if (!quantityInput || !plusButton || !variant) return;

      let cap = null;
      const trackedFiniteStock =
        variant.available &&
        variant.inventory_management === 'shopify' &&
        variant.inventory_policy !== 'continue' &&
        Number.isFinite(Number(variant.inventory_quantity)) &&
        Number(variant.inventory_quantity) > 0;

      if (trackedFiniteStock) {
        const cartQuantity = Number(quantityInput.dataset.cartQuantity || 0);
        cap = Math.max(0, Number(variant.inventory_quantity) - (Number.isFinite(cartQuantity) ? cartQuantity : 0));
        setStockMaxedInCart(cap <= 0, variant);
      } else if (variant?.quantity_rule?.max != null && Number.isFinite(Number(variant.quantity_rule.max))) {
        cap = Number(variant.quantity_rule.max);
        setStockMaxedInCart(false, variant);
      } else {
        setStockMaxedInCart(false, variant);
        quantityInput.removeAttribute('max');
        plusButton.disabled = false;
        plusButton.removeAttribute('aria-disabled');
        plusButton.removeAttribute('title');
        syncMinusButton();
        return;
      }

      const minQty = Number(quantityInput.min || 1);
      const normalizedCap = Math.max(minQty, cap);
      quantityInput.max = String(normalizedCap);
      const currentQty = Number(quantityInput.value || minQty);
      const atCap = currentQty >= normalizedCap;

      if (currentQty > normalizedCap) {
        quantityInput.value = String(normalizedCap);
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      plusButton.disabled = atCap;
      plusButton.setAttribute('aria-disabled', atCap ? 'true' : 'false');
      if (atCap) {
        plusButton.title = 'Max quantity reached';
      } else {
        plusButton.removeAttribute('title');
      }

      syncMinusButton();
    }

    const button = getMainButton();
    if (button) {
      const buttonObserver = new MutationObserver(syncPrimaryButtonLabel);
      buttonObserver.observe(button, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (priceContainer) {
      const priceObserver = new MutationObserver(() => {
        syncPrimaryButtonLabel();
        normalizeVisibleCurrency();
      });
      priceObserver.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        currentVariantState = event?.data?.variant || null;
        refreshCurrencyNodes();
        syncPrimaryButtonLabel();
        syncStockStatus(currentVariantState);
        applyQuantityCap(currentVariantState);
        syncMinusButton();
        normalizeVisibleCurrency();
        normalizeTaxNote();
      });
    }

    if (quantityInput) {
      const syncQuantityButtons = () => {
        if (currentVariantState) {
          applyQuantityCap(currentVariantState);
          syncMinusButton();
          return;
        }
        if (plusButton) {
          const maxAttr = Number(quantityInput.max || 0);
          const currentQty = Number(quantityInput.value || quantityInput.min || 1);
          if (Number.isFinite(maxAttr) && maxAttr > 0) {
            const atCap = currentQty >= maxAttr;
            plusButton.disabled = atCap;
            plusButton.setAttribute('aria-disabled', atCap ? 'true' : 'false');
            plusButton.title = atCap ? 'Max quantity reached' : '';
          }
        }
        syncMinusButton();
      };

      quantityInput.addEventListener('input', syncQuantityButtons);
      quantityInput.addEventListener('change', syncQuantityButtons);
    }

    if (plusButton) {
      plusButton.addEventListener(
        'click',
        (event) => {
          const maxAttr = Number(quantityInput?.max || 0);
          const currentQty = Number(quantityInput?.value || quantityInput?.min || 1);
          if (Number.isFinite(maxAttr) && maxAttr > 0 && currentQty >= maxAttr) {
            event.preventDefault();
            event.stopImmediatePropagation();
            plusButton.disabled = true;
            plusButton.setAttribute('aria-disabled', 'true');
            plusButton.title = 'Max quantity reached';
          }
        },
        true
      );
    }

    if (minusButton) {
      minusButton.addEventListener(
        'click',
        (event) => {
          const minQty = Number(quantityInput?.min || 1);
          const currentQty = Number(quantityInput?.value || minQty);
          if (currentQty <= minQty) {
            event.preventDefault();
            event.stopImmediatePropagation();
            minusButton.disabled = true;
            minusButton.setAttribute('aria-disabled', 'true');
            minusButton.title = 'Minimum quantity reached';
          }
        },
        true
      );
    }

    currentVariantState = getInitialVariantState();
    refreshCurrencyNodes();
    normalizeVisibleCurrency();
    normalizeTaxNote();
    syncPrimaryButtonLabel();
    syncStockStatus(currentVariantState);
    applyQuantityCap(currentVariantState);
    syncMinusButton();
  }

  function setupProductShare() {
    const shareButton = document.querySelector('[data-mio-share-button]');

    if (!shareButton) return;

    const status = document.querySelector('[data-mio-share-status]');
    const fallback = document.querySelector('[data-mio-share-fallback]');
    const fallbackInput = fallback ? fallback.querySelector('input') : null;
    const shareUrl = shareButton.getAttribute('data-share-url') || window.location.href;
    const shareTitle = shareButton.getAttribute('data-share-title') || document.title;

    function revealFallback() {
      if (!fallback || !fallbackInput) return;

      fallback.hidden = false;
      fallbackInput.focus({ preventScroll: true });
      fallbackInput.select();
    }

    function hideFallback() {
      if (fallback) fallback.hidden = true;
    }

    async function copyShareUrl() {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        await navigator.clipboard.writeText(shareUrl);
      } else {
        const input = document.createElement('input');
        input.value = shareUrl;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.top = '-1000px';
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
      }
    }

    shareButton.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: shareTitle, url: shareUrl });
          if (status) status.textContent = 'Share sheet opened.';
          hideFallback();
          return;
        }

        await copyShareUrl();
        if (status) status.textContent = 'Product link copied.';
        hideFallback();
      } catch (error) {
        if (error && error.name === 'AbortError') return;

        try {
          await copyShareUrl();
          if (status) status.textContent = 'Product link copied.';
          hideFallback();
        } catch (copyError) {
          revealFallback();
          if (status) status.textContent = 'Copy the product link from the field below.';
        }
      }
    });
  }

  function setupGalleryViewerArrows() {
    document.querySelectorAll('[data-mio-gallery-nav]').forEach((button) => {
      if (button.dataset.mioBound === 'true') return;
      button.dataset.mioBound = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        const direction = button.getAttribute('data-mio-gallery-nav');
        const mediaGallery = button.closest('media-gallery');
        if (!mediaGallery) return;

        const thumbnailItems = Array.from(
          mediaGallery.querySelectorAll('[id^="Slider-Thumbnails"] [data-target]')
        ).filter((item) => item.dataset.target);

        if (!thumbnailItems.length) return;

        const activeThumbIndex = thumbnailItems.findIndex((item) => {
          const thumbButton = item.querySelector('button');
          return thumbButton?.getAttribute('aria-current') === 'true';
        });
        const activeMedia = mediaGallery.querySelector('[id^="GalleryViewer"] [data-media-id].is-active');
        const activeMediaId = activeMedia ? activeMedia.dataset.mediaId : '';
        const currentThumbnail = thumbnailItems.findIndex((item) => {
          return item.dataset.target === activeMediaId;
        });
        const from = activeThumbIndex >= 0 ? activeThumbIndex : currentThumbnail >= 0 ? currentThumbnail : 0;
        const offset = direction === 'prev' ? -1 : 1;
        const nextIndex = (from + offset + thumbnailItems.length) % thumbnailItems.length;
        const target = thumbnailItems[nextIndex];
        const targetMediaId = target.dataset.target;

        if (!targetMediaId) return;

        const targetButton = target.querySelector('button');
        if (targetButton) {
          targetButton.click();
          targetButton.focus({ preventScroll: true });
          return;
        }

        if (typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(targetMediaId, false);
        }
      });
    });
  }

  function setupProductMediaModalFallback() {
    document.querySelectorAll('.mio-pdp .product__media-toggle').forEach((button) => {
      if (button.dataset.mioPdpModalFallbackBound === 'true') return;
      button.dataset.mioPdpModalFallbackBound = 'true';

      button.addEventListener('click', () => {
        const opener = button.closest('modal-opener');
        const modalSelector = opener ? opener.getAttribute('data-modal') : '';
        const modal = modalSelector ? document.querySelector(modalSelector) : null;

        if (!modal || typeof modal.show !== 'function') return;

        window.requestAnimationFrame(() => {
          if (!modal.hasAttribute('open')) {
            modal.show(button);
          }
        });
      });
    });
  }

  function setupProductBackToTopFallback() {
    const productRoot = document.querySelector('.mio-pdp');
    const button = document.querySelector('[data-mio-mobile-top-link]');

    if (!productRoot || !button || button.dataset.mioPdpTopFallbackBound === 'true') return;

    button.dataset.mioPdpTopFallbackBound = 'true';

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const isMobileMenuDrawerOpen = () => (
      mobileQuery.matches &&
      (
        document.documentElement.classList.contains('menu-drawer-open') ||
        document.body.classList.contains('menu-drawer-open')
      )
    );

    document.addEventListener('click', (event) => {
      const clickedButton = event.target?.closest?.('[data-mio-mobile-top-link]');

      if (clickedButton !== button) return;
      if (isMobileMenuDrawerOpen()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }, { capture: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupDesktopPurchaseRailOffset();
      setupPurchasePanelEnhancements();
      setupStickyAddToCart();
      setupProductShare();
      setupGalleryViewerArrows();
      setupProductMediaModalFallback();
      setupProductBackToTopFallback();
      if (window.customElements && typeof window.customElements.whenDefined === 'function') {
        window.customElements.whenDefined('media-gallery').then(setupGalleryViewerArrows);
      }
    }, { once: true });
  } else {
    setupDesktopPurchaseRailOffset();
    setupPurchasePanelEnhancements();
    setupStickyAddToCart();
    setupProductShare();
    setupGalleryViewerArrows();
    setupProductMediaModalFallback();
    setupProductBackToTopFallback();
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('media-gallery').then(setupGalleryViewerArrows);
    }
  }
})();
